module.exports = require('./AddressCell');
